import React, { Fragment } from "react";
import { Helmet } from "react-helmet-async";
import Navbar from "../../components/Navbar/Navbar";
import PageTitle from "../../components/pagetitle/PageTitle";
import Contactpage from "../../components/Contactpage/Contactpage";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Footer from "../../components/footer/Footer";
import Logo from "../../images/logo.webp";
import Phone from "../../images/telephone.svg";
import CursorMaus from "../../components/CursorMaus/CursorMaus";

const ContactPage = () => {
  return (
    <Fragment>
      <Helmet>
        <title>Contact | Cash Flow Summit 2026</title>
        <meta
          name="description"
          content="Get in touch with the Cash Flow Summit 2026 team for event details, partnership opportunities, and support."
        />
        <meta
          name="keywords"
          content="Cash Flow Summit contact, Cash Flow Summit support, Cash Flow Summit inquiry"
        />
        <meta name="author" content="Jagmohan Singh" />
        <meta name="robots" content="index, follow" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      </Helmet>
      <Navbar Logo={Logo} hclass={"wpo-site-header s3"} telephone={Phone} />
      <PageTitle pageTitle={"Contact Us"} pagesub={"Contact"} />
      <Contactpage />
      <Footer />
      <Scrollbar />
      <CursorMaus />
    </Fragment>
  );
};
export default ContactPage;
